import * as React from "react";
import styled, { css } from "styled-components";
import NavItemStateIndicator from "components/common/NavItemStateIndicator";
import { NAVBAR_GAP, NAV_ITEM_HEIGHT } from "theme/constants";
const NavigationLink = styled.a(
  ({ theme, $withMinHeight }) => css`
    color: ${theme.colors.text.primary};
    ${$withMinHeight && css`
      min-height: ${NAV_ITEM_HEIGHT};
    `}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-left: ${NAVBAR_GAP}px;
    padding-right: ${NAVBAR_GAP}px;

    &:hover,
    &:focus {
      color: ${theme.colors.variant.darker.default};
      background-color: transparent;

      text-decoration: none;
    }

    &:focus:not(:focus-visible) {
      outline: none;
    }
  `
);
const NavItem = ({
  children = void 0,
  withMinHeight = true,
  ...props
}) => /* @__PURE__ */ React.createElement(NavigationLink, { ...props, $withMinHeight: withMinHeight }, /* @__PURE__ */ React.createElement(NavItemStateIndicator, null, children));
NavItem.displayName = "NavItem";
export default NavItem;
